export default "__VITE_ASSET__CcROnldk__"